// export const BASE_URL = "http://192.168.1.28:5000/"; // LOCAL
export const BASE_URL = "http://crm.theteamrobotics.com:5000/"; // LIVE
export const WS_URL = "ws:143.110.187.231:8080";

export const URL = {
  CATEGORIES: "robots/categories",
  SHOW_CATEGORIES: "robots/show-category",
  GET_TABLE: "table/get-table",
  PLACE_ORDER: "place-order/create",
  LOGIN: "user/login",
  CREATE_CATEGORY: "robots/create-category",
  CREATE_ITEM: "robots/create-item",
  EDIT_CATEGORY: "robots/edit-category",
  DELETE_ITEM: "robots/delete-item",
  EDIT_ITEM: "robots/edit-item",
  STATUS_CHANGE: "robots/status-change",
  CREATE_TABLE: "table/create-table",
  EDIT_TABLE: "table/edit-table/",
  GET_TABLES: "table/get-table-admin",
  TABLE_STATUS_CHANGE: "table/status/",
  ORDER_LIST: "place-order/order-list",
  ORDER_DETAILS: "place-order/order-details/",
  LOGOUT: "user/logout",
};

export const TOKEN = "token";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";

export const NUMBER = /^\+?(0|[6-9]\d*)$/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const dashboardBanner = {
  loop: true,
  autoplay: true,
  center: true,
  dots: false,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};
